var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function Svg17(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 -1)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#CAC5C0",
    cx: 50,
    cy: 50.998,
    r: 50
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.711 20.152v49.307c0 5.879 2.43 8.814 7.285 8.814h1.148v3.322h-26.188v-3.322h1.789c4.938 0 7.41-2.936 7.41-8.814v-32.318c0-5.957-2.129-8.941-6.387-8.941h-2.559v-3.32h1.023c5.109 0 9.711-1.576 13.797-4.727l2.682-.001zm32.707 61.825h-8.945v-1.02c0-5.707 1.789-12.902 5.363-21.586 5.453-12.949 10.48-22.912 15.074-29.893l.516-.895h-20.953c-3.066 0-5.387.639-6.961 1.912-1.574 1.279-2.793 3.41-3.645 6.389h-3.445l3.832-16.861h2.301c1.273.598 3.578.895 6.898.895h27.59v4.855c-1.02 1.449-2.297 3.746-3.832 6.896-2.984 5.795-5.707 12.521-8.176 20.182-3.664 11.415-5.535 21.126-5.617 29.126z",
    fill: "#0D0F0F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg17);
export default __webpack_public_path__ + "static/media/17.a493c6f5a77ae0b85c7b9f9911fb707e.svg";
export { ForwardRef as ReactComponent };